export default {
  groupProfile: {},
  groupProfiles: {},
  invitedGroup: "",
};
